import { useDispatch, useSelector } from 'react-redux'

import { EuiLoadingContent, EuiPanel, EuiPageHeader, EuiPageHeaderSection, EuiTitle, EuiButtonEmpty } from '@elastic/eui'

import { Account } from 'api/interfaces'
import { updateAccountState } from 'app/appSlice'
import { showSuccessToast } from 'app/appSlice'
import { RootState } from 'app/rootReducer'
import { open } from 'features/organization/organizationSlice'

import { useWhiteLabel } from '../../whiteLabel/WhiteLabelContext'
import { AccountSettingsForm } from './AccountSettingsForm'

const AccountDrawer = () => {
  const dispatch = useDispatch()
  const account = useSelector((state: RootState) => state.account)
  const { isVendastaUser, isShopifyUser } = useSelector((state: RootState) => state.app)
  const { currentAccount } = useSelector((state: RootState) => state.app)
  const whiteLabel = useWhiteLabel()

  return (
    <>
      <EuiPageHeader>
        <EuiPageHeaderSection>
          <EuiTitle>
            <h1>Settings{whiteLabel?.isAgencies() && `: ${currentAccount?.name}`}</h1>
          </EuiTitle>
        </EuiPageHeaderSection>
        {!isVendastaUser && !isShopifyUser && (
          <EuiPageHeaderSection>
            <EuiButtonEmpty
              id='manageSubscription'
              onClick={() => {
                dispatch(open())
              }}>
              Manage Subscription
            </EuiButtonEmpty>
          </EuiPageHeaderSection>
        )}
      </EuiPageHeader>
      <EuiPanel grow={false}>
        {account.isLoading || currentAccount == null ? (
          <EuiLoadingContent lines={3} />
        ) : (
          <AccountSettingsForm
            isNewAccount={false}
            onSubmit={(account: Account) => {
              dispatch(showSuccessToast('Saved account'))
              dispatch(updateAccountState(account))
            }}
          />
        )}
      </EuiPanel>
    </>
  )
}

export default AccountDrawer
